import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { User, UserRole } from '../../core/models';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RolePermissionViewService, UserService,  } from '../../core/services';
import { UserDoc } from '../../core/schema/user-schema';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core';
import { asyncScheduler } from 'rxjs';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends FesBaseComponent implements OnInit, OnDestroy  {


  @Input() set user( user : UserDoc ) {
    if ( user ) {
      this._user = user
      this.tmpUser = { ...user.toJSON() }
      this.tmpUser.password = ''
    } else {
      this.tmpUser = new User()
      this.tmpUser.role = "field"
    }
  }
  _user : UserDoc
  tmpUser : User

  get user() { return this._user }

  userRoles : UserRole[]

  protected srcUser : User
  public bProcessing = false
  public errorMsg : string = ''

  constructor( 
      appState : AppState,
      protected editModal : BsModalRef,
      private userService: UserService, 
      private rolePermissionViewService : RolePermissionViewService ) {
        super(appState)      
  }

  ngOnInit(): void {
    const rolesQuery = this.rolePermissionViewService.createRoleQuery()
    this.subscribe( rolesQuery, (roles:UserRole[]) => this.userRoles = roles )
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  async onSave() {
    this.errorMsg = ''
    this.bProcessing = true;
    try {
      if ( !this.tmpUser._id ) {
        await this.userService.create(this.tmpUser).toPromise()
      } else {
        await this.userService.update(this.tmpUser).toPromise()
      }
      this.editModal.hide()
    } catch ( error ) {
      this.errorMsg = this.userService.extractErrorMsg(error)
      this.userService.publishError(error,this)
    } finally {
      asyncScheduler.schedule( () => this.userService.syncNow() )
      this.bProcessing = false
    }
  }

  onCancel() {
    this.editModal.hide()
  }
}
